import { defineComponent, watchEffect, createBlock, createCommentVNode, unref, openBlock, withCtx, createTextVNode, toDisplayString } from "vue";
import { isFilled, asText } from "@prismicio/client";
import { DEV } from "esm-env";
import _sfc_main$1 from "./lib/Wrapper.vue.js";
import { devMsg } from "./lib/devMsg.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PrismicText" },
  __name: "PrismicText",
  props: {
    field: {},
    fallback: {},
    separator: {},
    wrapper: {}
  },
  setup(__props) {
    const props = __props;
    if (DEV) {
      watchEffect(() => {
        if (typeof props.field === "string") {
          throw new Error(
            `[PrismicText] The "field" prop only accepts a Rich Text or title field's value but was provided a different type of field instead (e.g. a Key Text or Select field). You can resolve this error by rendering the field value inline without <PrismicText>. For more details, see ${devMsg(
              "prismictext-works-only-with-rich-text-and-title-fields"
            )}`
          );
        }
      }, {});
    }
    return (_ctx, _cache) => {
      return unref(isFilled).richText(_ctx.field) || _ctx.fallback ? (openBlock(), createBlock(_sfc_main$1, {
        key: 0,
        wrapper: _ctx.wrapper
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(unref(asText)(_ctx.field) || _ctx.fallback), 1)
        ]),
        _: 1
      }, 8, ["wrapper"])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=PrismicText.vue.js.map
